export enum BookType {
  Visit = 'VISIT', // Besuche
  Consultation = 'CONSULTATION', // Sprechstunde
  Surgery = 'SURGERY', //OP
  Ward = 'WARD' // Station
}
